import { AlertActionTypes } from 'util/modules/Alert/redux/types'
/**
* Data Types
*/

import { PaginationOpts } from 'util/types/index'

export interface Category {
  id: number,
  name: string,
  description?: string,
  pictureSmall: string,
  pictureMedium: string,
  createdAt: string,
  updatedAt?: string
}

/**
* State Type
*/

export interface CategoryState {
  readonly category?: Category
  readonly categoryList: { items: Category[], pagination?: PaginationOpts }
}

/**
* Action Enum Types
*/

export enum CategoryTypes {
  CATEGORY_CREATE = 'CATEGORY/CREATE',
  CATEGORY_UPDATE = 'CATEGORY/UPDATE',
  CATEGORY_DELETE = 'CATEGORY/DELETE',
  CATEGORY_GET = 'CATEGORY/GET',
  CATEGORY_LIST = 'CATEGORY/LIST'
}

/**
* Action Types
*/
interface CreateCategory {
  type: typeof CategoryTypes.CATEGORY_CREATE,
  payload: Category
}

interface UpdateCategory {
  type: typeof CategoryTypes.CATEGORY_UPDATE,
  payload: Category
}

interface DeleteCategory {
  type: typeof CategoryTypes.CATEGORY_DELETE,
  payload: number
}

interface GetCategory {
  type: typeof CategoryTypes.CATEGORY_GET,
  payload: Category
}

interface GetCategoryList {
  type: typeof CategoryTypes.CATEGORY_LIST,
  payload: Category[]
  pagination?: PaginationOpts
}

export type CategoryActionTypes = (
  AlertActionTypes | CreateCategory | UpdateCategory | DeleteCategory | GetCategory | GetCategoryList
)
